<template lang="html">
  <el-dialog
  title="提示"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
  <el-form :model="withdrawCashForm" ref="withdrawCashForm" :rules="rules" label-width="120px">
    <el-form-item label="提现到微信" prop="account">
      <el-input v-model="withdrawCashForm.account" disabled>
      </el-input>
      <span style="color:#f56c6c;font-size:12px;">请仔细确认收款账户！</span>
    </el-form-item>
    <el-form-item label="提现金额"  prop="money">
      <el-input placeholder="请输入整数金额" type="number" v-model="withdrawCashForm.money">
      </el-input>
      <span style="color:#f56c6c;font-size:12px;">可提现金额：{{canUseMoney}}元，其余在途资金{{otherMoney}}元</span>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="validateFrom('withdrawCashForm',entPay)">确 认 提 现</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </el-form-item>
  </el-form>
</el-dialog>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import ChannelModel from '@/framework/models/channelModel'
export default {
  extends: BasicPager,
  name: 'withdraw-cash-dialog',
  data: function () {
    var validateMoney = (rule, value, callback) => {
      let that = this
      if (!value) {
        callback(new Error('请输入提现金额'))
        return
      }

      if (value === 0) {
        callback(new Error('金额不能为0'))
        return
      }

      // if (value < 100) {
      //   callback(new Error('提现金额必须大于等于100'));
      //   return;
      // }

      if (value > that.canUseMoney) {
        callback(new Error('提现金额超过可提现金额'))
        return
      }

      callback()
    }

    return {
      withdrawCashForm: {
        account: null,
        money: null
      },
      rules: {
        money: [
          { validator: validateMoney, trigger: 'blur' }
        ]
      },
      dialogVisible: false
    }
  },
  props: {
    otherMoney: {
      type: Number,
      default: function () {}
    },
    canUseMoney: {
      type: Number,
      default: function () {}
    }
  },
  methods: {
    entPay: function () {
      // 不是渠道不进行查询
      if (this.loginInfo.loginPath != 'channel') {
        return
      }

      let _this = this
      let params = {
        channelId: this.loginInfo.id,
        amount: this.withdrawCashForm.money
      }

      let listener = {
        success: function (dataInfo) {
          _this.$message({
            message: '提现成功，请到微信钱包查收。',
            type: 'success'
          })
          _this.dialogVisible = false
          location.reload()
        }
      }
      ChannelModel.entPay(_this, params, listener)
    },
    show: function (nickname) {
      this.withdrawCashForm.account = '微信账户 - ' + nickname
      this.dialogVisible = true
    },
    handleClose: function (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    }
  }
}
</script>

<style lang="css">
</style>
